import { useEffect, useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, DateInput, EmailInput, PhoneInput, Select, TextareaInput, TextInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { useApi } from "../../hooks/useApi"
import { useTitleOptions } from "./Contacts"

const useActions = () => {
    const t = useTranslations()
    return {
        [t("Aperçu plainte")]: x => window.open(`${process.env.REACT_APP_API_URL}/plaintes/${x.id}/pdf`, '_blank').focus()
    }
}

function PlainteFields({ item, set, tab }) {
    const [client, setClient] = useState()
    const t = useTranslations()
    const typeDePlainteOptions = useOptions('typeDePlaintes', 'nom')
    const chantierOptions = useOptions('chantiers', 'nom', { query: item?.clientId ? `clientId=${item?.clientId}` : undefined })
    const personnelOptions = useOptions('personnel', ['prenom', 'nom'], { label: x => `${x.prenom || ''} ${x.nom || ''}`, query: `or2:dateFin=&or2:dateFin:gt=${new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000).toISOString()}` })
    const contactOptions = useOptions('contacts', ['nom', 'fonction'], { label: x => `${x.nom} ${x.fonction ? `(${x.fonction})` : ''}`, query: client ? `or2:clientId=${client.id}&or2:gerantId=${client.gerantId}` : '' })
    const titreOptions = useTitleOptions()

    const api = useApi()
    useEffect(() => {
        if (item?.clientId) {
            api.get(`/clients/${encodeURIComponent(item.clientId)}`).then(setClient)
        } else setClient(null)
    }, [item?.clientId])

    const changeContact = (id, item) => {
        set('contactId')(id)
        if (item) {
            set('contactTitre')(item.titre)
            set('contactNom')(item.nom)
            set('contactEmail')(item.email)
            set('contactTel')(item.tel || item.mobilophone)
        }
    }

    return <>
        <Row>
            <DateInput label={t("Date")} value={item.date} onChange={set('date')} required />
            <AsyncSelect label={t("Chantier")} value={item.chantierId} onChange={set('chantierId')} options={chantierOptions} />
            <AsyncSelect label={t("Personnel")} value={item.personnelId} onChange={set('personnelId')} options={personnelOptions} required />
            <AsyncSelect label={t("Type")} value={item.typeDePlainteId} onChange={set('typeDePlainteId')} options={typeDePlainteOptions} required add="/typeDePlaintes/new" />
        </Row>
        <Row>
            <AsyncSelect label={t("Chercher plaignant")} value={item.contactId} onChange={changeContact} options={contactOptions} />
            <Select label={t("Titre du plaignant")} value={item.contactTitre} onChange={set('contactTitre')} options={titreOptions} />
            <TextInput label={t("Nom du plaignant")} value={item.contactNom} onChange={set('contactNom')} required />
        </Row>
        <Row>
            <EmailInput label={t("Email du plaignant")} value={item.contactEmail} onChange={set('contactEmail')} />
            <PhoneInput label={t("Téléphone du plaignant")} value={item.contactTel} onChange={set('contactTel')} />
        </Row>
        <TextareaInput label={t("Objet")} value={item.objet} onChange={set('objet')} required />
        <TextareaInput label={t("Réponse")} value={item.reponse} onChange={set('reponse')} />
        <Row>
            <DateInput label={t("Date de clôture")} value={item.dateCloture} onChange={set('dateCloture')} />
        </Row>
    </>
}

export function PlaintesList(props) {
    const t = useTranslations()
    const actions = useActions()
    return <ListPage model="plaintes" title={t("Plaintes")} columns={{
        [t('Date')]: 'date',
        [t('Plaignant')]: 'contactNom',
        [t('Objet')]: 'objet',
    }} actions={actions} {...props} />
}

export function PlainteDetail(props) {
    const t = useTranslations()
    const actions = useActions()
    return <DetailPage model="plaintes" title={t("Plainte")} Fields={PlainteFields} actions={actions} {...props} />
}
